export default {
    filterCommonLoading: "Loading...",
    filterCommonNoData: "No Data",
    
    hiringLocation: 'Hiring Location',
    dateRange: 'Date range',
    marketGalleries: 'Galleries',
    marketGalleriesPlaceholder: 'Enter Galleries',
    marketCategories: 'Categories',
    marketCategoriesPlaceholder: "Enter Categories",
    newsLocations: 'News Locations',
    publishedDateRange: "Published Date range",
    industryCategories: "Industry Categories",
    industryCategoriesPlaceholder: "Enter Industry Categories",
    industrySubCategories: "Sub-Industry Categories",
    sequencePlaceholder: 'Enter Sequence Name',
    pageviewGreaterThan: "Pageview",
    sessionGreaterThan: "Session",
    advertisements: "Advertisement",
    accountLocation: "Account Location",
    startDate: "Start Date",
    endDate: "End Date",
    inputNumberMin: 'Min',
    inputNumberMax: 'Max',
    postingLocation: "Posting Location",

    filterJob: 'Job search',
    filterJobPostingDateSubTitle: 'Posting Date Period',
    filterJobPostingLocation: "Posting Location",
    filterJobTitlesSubTitle: 'Job Titles',

    filterNews: 'News',
    filterNewsPublishedDateSubTitle: 'Published Date Period',
    filterNewsCategories: "Categories",

    filterEmployeeCustomRange: 'Custom range',

    filterAdvancedSearch: "Advanced search",
    allSearchResultsFor: 'All search results for "{count}"',
    filterAdvancedSearchTooltip: 'Finds results by meaning, not just exact words.',

    filterSpecialties: "Specialties",
    filterSpecialtiesPlaceHolder: 'Enter Specialties',
    
    filterIndustrySubCategories: "Sub-Industry",
    filterIndustrySubCategoriesPlaceHolder: 'Enter Sub-Industry',

    filterAdPlaceholder: 'Enter Advertisement',

    filterEmployeesPlaceholder: 'Select Employees',

    filterLocationExcludeText: "Exclude selected locations",
    filterLocationExcludeTooltip: "When enabled, these locations will be filtered out from your results.",

    filterManagementPlaceholder: "Enter Management Levels",

    filterJobFunctionPlaceholder: "Enter Job Function",

    filterDepartmentPlaceholder: "Enter Departments",
    
    filterPage: "Page",
    filterPerPage: "Per page",


    

    filterCompanyPlaceHolder: 'Enter Companies',
    filterCompanyCSVImport: "Easily import a list of companies you already have",
    filterCompanyCSVText: "Import company list (CSV)",

    csvComponentTitle1: "Upload CSV",
    csvComponentTitle2: 'Review Upload',
    csvTipNeedHelp: 'Need help?',
    detectFileNumber: 'Detected {count} companies',
    uploadLoading: 'uploading...',
    uploadReplace: 'Replace',
    noCompaniesWereDetectedInYourFile: 'No companies were detected in your file. Please check your data and upload again.',
    fileContainsManyCompanies: "Your file contains many companies, only the first {count} will be used.",
    onlyReturnOneResultPerCompany: 'Only return 1 result per company',
    btnViewCompanyList: 'View company list',
    csvFileAnalysisFailed: 'CSV file analysis failed, please try again later',
    downloadFailed: "Download failed. Please try again.",
    downloadSampleCsv: 'Download Sample CSV',
    firstHundredEntriesWillBeProcessed: 'Only the first {count} entries per file will be processed.',
    detectingCompaniesInFile: "Detecting companies in your file...",
    thisMayTakeAFewSeconds: 'This may take a few seconds.',

    filterSaveText: 'Save search',
    filterClearAllText: 'Clear all',

    filterRemoved: 'Filter removed',

};